module.exports = __webpack_public_path__ + "static/media/welcome.ac8627fb.png";